export default __webpack_public_path__ + "static/media/ic-ViewMovil.0fd38780.png";